import React from 'react'
import ListAltIcon from '@material-ui/icons/ListAlt';
import TodayIcon from '@material-ui/icons/Today';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import ScheduleIcon from '@material-ui/icons/Schedule'; // for 'display today...
import ListIcon from '@material-ui/icons/List'; // for list all entries..
import AddIcon from '@material-ui/icons/Add';
import { IconButton, Icon } from '@material-ui/core';


const Home = (props) => {
  const { onToggle } = props;
  return (
    <div>
      <p>
        <IconButton
          onClick={onToggle('todos')}
        >
          <ListAltIcon />
        </IconButton><strong

        >Todos</strong> ...</p>
      <p>
        <IconButton
          onClick={onToggle('calendar')}
        >
          <TodayIcon />
        </IconButton>

        <strong>View schedule</strong>
        ... (open calendar for current month, with current day and current week highlighted)
       By clicking on the day go to that day, by clicking on the week go to weekly overview.
      </p>
      <p>
        <IconButton
          onClick={onToggle('display')}
        >
          <ListIcon />
        </IconButton>
        <strong>List all entries</strong>
      </p>
      <p>
        <IconButton
          onClick={onToggle('display')}
        >
          <ScheduleIcon />
        </IconButton>
        <strong>Today</strong> ... list entries for today (if there are any ... )
      </p>
      <p>
        <IconButton
          onClick={onToggle('form')}
        >
          <AddIcon />
        </IconButton>
        <strong>Add new entry</strong> ... probably a FAB for this...
      </p>
    </div>
  )
}

export default Home
